/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Mentions_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Any file, space, or artifact in the current project. A mentioned space lets the assistant search everything inside it, while a mentioned file adds that singl..." |
*
* @param {Uno_Edu_Chat_Mentions_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_mentions_chip2_answer = /** @type {((inputs?: Uno_Edu_Chat_Mentions_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Mentions_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jede Datei, jeden Space oder jedes Artefakt im aktuellen Projekt. Ein erwähnter Space lässt den Assistenten alles darin durchsuchen, während eine erwähnte Datei nur dieses eine Dokument hinzufügt.")
	return /** @type {LocalizedString} */ ("Any file, space, or artifact in the current project. A mentioned space lets the assistant search everything inside it, while a mentioned file adds that single document.")
});